
//extending jquery mobile for up and down swipes
(function( $, window, undefined ) {

    //custom handleSwipe with swiperight, swipeleft, swipeup, swipedown
    $.event.special.swipe.handleSwipe = function( start, stop, thisObject, origTarget ) {
		
        if ( stop.time - start.time < $.event.special.swipe.durationThreshold ) {
			
            var horSwipe = Math.abs( start.coords[0] - stop.coords[0] ) > $.event.special.swipe.horizontalDistanceThreshold;
            var verSwipe = Math.abs( start.coords[1] - stop.coords[1] ) > $.event.special.swipe.verticalDistanceThreshold;
            if( horSwipe != verSwipe ) {
				
                var direction;
                if(horSwipe)
                    direction = start.coords[0] > stop.coords[0] ? "swipeleft" : "swiperight";
                else
                    direction = start.coords[1] > stop.coords[1] ? "swipeup" : "swipedown";
                $.event.trigger($.Event( "swipe", { target: origTarget, swipestart: start, swipestop: stop }), undefined, thisObject);
                $.event.trigger($.Event( direction, { target: origTarget, swipestart: start, swipestop: stop }), undefined, thisObject);
                return true;
            }
            return false;
        }
        return false;
    }

    //do binding
    $.each({
        swipeup: "swipe.up",
        swipedown: "swipe.down"
    }, function( event, sourceEvent ) {
        $.event.special[ event ] = {
            setup: function() {
                $( this ).bind( sourceEvent, $.noop );
            },
            teardown: function() {
                $( this ).unbind( sourceEvent );
            }
        };
    }); 
})( jQuery, this );

(function( $ ) {

	var touchpoints = {};

	$(document).bind('touchstart', function(e){
		touchpoints['startelem'] = e.target;
		touchpoints['starty'] = e.originalEvent.touches ?  e.originalEvent.touches[0].pageY : e.pageY;
		touchpoints['startx'] = e.originalEvent.touches ?  e.originalEvent.touches[0].pageX : e.pageX;
		touchpoints['starttime'] = $.now();
	});

	$(document).bind('touchmove', function (e) {
		touchpoints['cury'] = e.originalEvent.touches ?  e.originalEvent.touches[0].pageY : e.pageY;
		touchpoints['curx'] = e.originalEvent.touches ?  e.originalEvent.touches[0].pageX : e.pageX;
	});

	$(document).bind('touchend', function (e) {	
		touchpoints['endelem'] = e.target;
		touchpoints['endy'] = touchpoints['cury'];
		touchpoints['endx'] = touchpoints['curx'];
		/*
		touchpoints['endy'] = e.originalEvent.touches && e.originalEvent.touches[0] ?  e.originalEvent.touches[0].pageY : e.pageY;
		touchpoints['endx'] = e.originalEvent.touches && e.originalEvent.touches[0] ?  e.originalEvent.touches[0].pageX : e.pageX;
		*/
		touchpoints['stoptime'] = $.now();
		$.event.special.swipe.handleSwipe({
			"time":touchpoints.starttime,
			"coords":[touchpoints.startx,touchpoints.starty]
		},
		{
			"time":touchpoints.stoptime,
			"coords":[touchpoints.endx,touchpoints.endy]
		},
		touchpoints.endelem,
		touchpoints.startelem
		);
		touchpoints = {};
	});

})( jQuery );


//extending jquery to allow scrolling with drag.
(function($) {
  $.fn.dragScroll = function(options) {
    var settings = $.extend({
      scrollVertical: true,
      scrollHorizontal: true,
      cursor: null
    }, options);

    var clicked = false,
      clickY, clickX, orgposY, orgposX;

    var getCursor = function() {
      if (settings.cursor) return settings.cursor;
      if (settings.scrollVertical && settings.scrollHorizontal) return 'move';
      if (settings.scrollVertical) return 'row-resize';
      if (settings.scrollHorizontal) return 'col-resize';
    }

    var updateScrollPos = function(e, el) {
      $('html').css('cursor', getCursor());
      var $el = $(el);
      settings.scrollVertical && $el.scrollTop(orgposY + (clickY - e.pageY));
      settings.scrollHorizontal && $el.scrollLeft(orgposX +(clickX - e.pageX));
	  
	  //settings.scrollVertical && $el.scrollTop($el.scrollTop() + (clickY - e.pageY));
      //settings.scrollHorizontal && $el.scrollLeft($el.scrollLeft() + (clickX - e.pageX));
    }

    $(this).on({
      'mousemove': function(e) {
        clicked && updateScrollPos(e, this);
      },
      'mousedown': function(e) {
        clicked = true;
        clickY = e.pageY;
        clickX = e.pageX;
		orgposX = $(this).scrollLeft();
		orgposY = $(this).scrollTop();
      },
      'mouseup': function() {
        clicked = false;
        $('html').css('cursor', 'auto');
      }
    });
	$(document).on({
		'mouseup' : function(){
			clicked= false;
			$('html').css('cursor', 'auto');
		}
	})
  }
}( jQuery ));

